export const getPrestCrossedPrice = (prest, isHaveQuoteResponse) => {
    if (!prest.maxPromo) return null
    if (!prest.crossedPrice || prest.crossedPrice === 0) throw new Error("crossedPrice must exist and be a positive number")

    if (prest.maxPromo < 5) return null

    if (prest.codePackage === "HS" || isHaveQuoteResponse) {
        return prest.crossedPrice
    } else {
        return prest.crossedPrice * prest.maxCapacity
    }
}

const priceWithoutFee = (prest) => {
    if (!prest.pricePerLogementWithoutFee) return null
    if (prest.pricePerLogementWithoutFee <= 0) throw new Error("pricePerLogementWithoutFee must be a positive number")
    return prest.pricePerLogementWithoutFee
}    

const priceWithFee = (prest) => {
    if (!prest.pricePerLogement) return null
    if (prest.pricePerLogement <= 0) throw new Error("pricePerLogement must be a positive number")
    return prest.pricePerLogement
}    


export const getPrestTotalPrice = (prest) => {
    return prest.codePackage === 'HS' ? priceWithFee(prest) : priceWithoutFee(prest)
}


export const getPrestPerPrice = (prest, participantsNum) => {
    return prest.codePackage === 'HS' ? parseInt(priceWithFee(prest) / participantsNum) : parseInt(priceWithoutFee(prest) / participantsNum)
}


export const getPrestMaxPromo = (prest) => {
    if (!prest.maxPromo) return null
    return prest.maxPromo >= 5 ? prest.maxPromo : null
}